import { render, staticRenderFns } from "./PairwiseRelsCards.vue?vue&type=template&id=57eeb4be&"
import script from "./PairwiseRelsCards.vue?vue&type=script&lang=js&"
export * from "./PairwiseRelsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports